export default __webpack_public_path__ + "static/media/aboutuscropped.755a877b.mp4";